var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Spinner } from "native-base";
import IconButton from "../atoms/IconButton";
import DocumentItem from "./DocumentItem";
const DocumentListCard = (_a) => {
    var { leftIconName, rightIconName, label, subText, note, onChangeNote, onChangeService, isEditable, loading, onRightIconPress } = _a, rest = __rest(_a, ["leftIconName", "rightIconName", "label", "subText", "note", "onChangeNote", "onChangeService", "isEditable", "loading", "onRightIconPress"]);
    return (_jsxs(Box, Object.assign({ px: isEditable ? 0 : 4, py: isEditable ? 4 : 6, borderBottomWidth: isEditable ? 1 : undefined, borderColor: "gray.100", width: "full", justifyContent: "space-between", flexDirection: "row" }, rest, { children: [_jsx(DocumentItem, { iconName: leftIconName, variant: "ghostGreen", iconSize: "2xl", label: label, subText: subText, comment: note, onChangeComment: onChangeNote, onChangeService: onChangeService, isEditable: isEditable }), loading ? (_jsx(Box, Object.assign({ alignItems: "flex-start", mr: 2 }, { children: _jsx(Spinner, { color: "green.500" }) }))) : (_jsx(IconButton, { alignItems: {
                    base: "flex-start",
                    md: "flex-start",
                }, onPress: onRightIconPress, iconName: rightIconName, variant: "lightGray", size: "sm" }))] })));
};
export default DocumentListCard;
